import { Route, Routes } from 'react-router-dom';
import './App.css';
import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import ChatPage from './Pages/Chat';
import HomePage from './Pages/HomePage';
import ChooseOptionPage from './Pages/TalkOptions';
import Navbar from './Pages/Navbar';
import SignupPage from './Pages/SignUpPage';
import CustomScrollbar from './Pages/CustomScrollbar';
import PhoneLoginPage from './Pages/LoginPage';
import Parents from './Pages/Parents';
import Mentors from './Pages/Mentors';
import Friend from './Pages/Friend';
// G-TMYTFM7ERS
function App() {

  useEffect(() => {
    ReactGA.initialize('G-TMYTFM7ERS');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <div className="App">
      <Navbar />
      <CustomScrollbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/get-start-talk" element={<ChooseOptionPage />} />
        <Route path="/loved-ones" element={<ChatPage />} />
        <Route path="/SignupPage" element={<SignupPage />} />
        <Route path="/PhoneLoginPage" element={<PhoneLoginPage />} />
        <Route path="/parents" element={<Parents />} />
        <Route path="/mentors" element={<Mentors />} />
        <Route path="/friends" element={<Friend />} />
      </Routes>
    </div>
  );
}

export default App;
